// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';
import VueResource from 'vue-resource';
import ElementUI from 'element-ui';
import AuthPlugin from '@/plugins/auth0';
import VueAnalytics from 'vue-analytics';
import JsonCSV from 'vue-json-csv';
import '@/scss/foodie-wizeline-tea.scss';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css'; // responsive utility classes
import store from '../store';
import router from './router';
import i18nSetup from './i18n';
import App from './App';
import AppConfig from '../config/appConfig';

Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.use(VueRouter);

Vue.use(AuthPlugin); // Auth0 plugin

Vue.use(AppConfig);

Vue.use(VueI18n);
Vue.component('downloadCsv', JsonCSV);

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  ...i18nSetup.config,
});

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});

Vue.use(VueAnalytics, {
  id: process.env.ANALYTICS_ID,
  router,
  autoTracking: {
    screenview: true,
    pageviewOnLoad: false,
  },
});

/* eslint-disable no-new */
const app = new Vue({
  router,
  store,
  components: { App },
  template: '<App/>',
  i18n,
}).$mount('#app');

const getUserInfo = async () => {
  const user = app.$auth0.getUser();
  return user;
};

export { getUserInfo };

export default app;



// WEBPACK FOOTER //
// ./src/main.js